import GlobalSidebarItem from '../../components/sidebar/GlobalSidebar/GlobalSidebarItem';

const NotebookSidebar = ({ currentScreen, onScreenChange }) => {
  const menuItems = [
    { id: 'my-notebooks', label: 'My Notebooks', icon: 'BookOpen' },
    { id: 'chapter-wise', label: 'Chapter-wise', icon: 'ListNumbers', badge: false },
    { id: 'test-wise', label: 'Test-wise', icon: 'ClipboardText', badge: false },
  ];

  return (
    <div className="w-full max-w-sm mx-auto py-6 font-[Inter]">
      <h2 className="text-2xl font-bold px-4 ml-4 mb-6 text-[var(--q3-neutral-default)]">All Notebooks</h2>
      <nav className="flex flex-col gap-3 px-4">
        {menuItems.map((item) => (
          <GlobalSidebarItem
            key={item.id}
            icon={item.icon}
            title={item.label}
            badge={item.badge}
            isSelected={currentScreen === item.id}
            onClick={() => onScreenChange(item.id)}
          />
        ))}
      </nav>
    </div>
  );
};

export default NotebookSidebar;
